import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import MobileHeaderCountdown from "./MobileHeaderCountdown/MobileHeaderCountdown";
import Countdown from "../common/Countdown/Countdown";
import TrustBox from "../common/TrustBox/TrustBox";
import Button from "../common/Button";
import logo from "../../extensions/images/rafflehouse-logo.svg";
import { getCharityLogoUrl } from "../../helpers/getCharityLogoUrl";

import "./styles.scss";

const Header = (props) => {
  const [isHidden, setIsHidden] = useState(false);
  const headerRef = useRef();
  const prev = useRef(0);
  let classHide = isHidden ? "hide" : "";
  const charityLogo = getCharityLogoUrl(process.env.REACT_APP_CHARITY_NAME);
  const charityName = process.env.REACT_APP_CHARITY_NAME;
  const hideHeader = (e) => {
    if (window.scrollY > headerRef.current.offsetHeight) {
      window.scrollY > prev.current ? setIsHidden(true) : setIsHidden(false);
    } else {
      setIsHidden(false);
    }
    prev.current = window.scrollY;
  };
  const renderCountdown = ({ isTop } = {}) => {
    let stepperCountdown = null;
    if (props.raffle != null) {
      if (props.raffle.stepperCountdown) {
        stepperCountdown = props.raffle.stepperCountdown;
      }
    }

    if (
      stepperCountdown != null &&
      stepperCountdown.isActive &&
      dayjs().isBefore(dayjs(stepperCountdown.endsAt))
    ) {
      if (isTop) {
        let value = stepperCountdown.title;
        return (
          <div className="header__top">
            <MobileHeaderCountdown
              prizeType="not-raffle"
              endsAt={stepperCountdown.endsAt}
              text={value}
            />
          </div>
        );
      }
      return (
        <div className="header-countdown-block">
          <h3>{stepperCountdown.title}</h3>
          <span className="header-countdown-block__devider">:&nbsp;</span>
          <div>
            <Countdown
              isHeader
              prizeType="not-raffle"
              endsAt={stepperCountdown.endsAt}
            />
          </div>
        </div>
      );
    }
  };
  useEffect(() => {
    if (typeof window == "object") {
      window.addEventListener("scroll", hideHeader);
    }
    return () => {
      if (typeof window == "object") {
        window.removeEventListener("scroll", hideHeader);
      }
    };
  }, []);

  return (
    <header className={`header ${classHide}`} ref={headerRef}>
      <div className="header__grid">
        <div className="header__left">{renderCountdown()}</div>
        <a href={process.env.REACT_APP_BASE_URL} className="header__logo">
          <img src={logo} alt="raffle-house-logo" />
        </a>
        <nav className="header__nav">
          <ul>
          {props.bonusDraw && (
            <li>
              <a
                href={process.env.REACT_APP_BASE_URL + "/early-bird"}
                target="_self"
                rel="noopener noreferrer"
              >
                The Early Bird
              </a>
            </li>
          )}
            <li>
              <a
                href={process.env.REACT_APP_BASE_URL + "/charity-raffle"}
                target="_self"
                rel="noopener noreferrer"
              >
                Our сharities
              </a>
            </li>
          </ul>
          <div className="header-enter-now-button-wrapper">
            <Button.Animated
              variant="secondary"
              size="md"
              onClick={props.onCTAClick}
            >
              Enter now
            </Button.Animated>
          </div>
        </nav>
      </div>
      <div className="header-trustpilot">
        <div className="trust-wrapper">
          <TrustBox isHeader />
        </div>
      </div>
      <img className="charity-image" src={charityLogo} alt={charityName} />
    </header>
  );
};

export default Header;
